export type EntityNode = {
  createdAt: string; // was DateTime
  deletedAt?: string | null; // was Maybe<DateTime>
  id: string; // was ID
  updatedAt: string; // was DateTime
};

export type Payment = EntityNode & {
  amount: number; // Int
  errorMessage?: string | null;
  metadata?: any | null; // JSON
  method: string;
  receipt?: string | null;
  state: string;
  surchargeAmount?: number | null;
  totalAmount: number; // Int
  transactionRef?: string | null;
};

export enum TransactionSource {
  ADMIN_API = "ADMIN_API",
  PAYMENTS_API = "PAYMENTS_API",
}

export enum TransactionType {
  PURCHASE = "PURCHASE",
  REFUND = "REFUND",
}

export type ErrorResult = {
  errorCode: string;
  message: string;
};

export type Transaction = EntityNode & {
  amountInCents: number;
  cancelledAt?: string | null;
  completedAt?: string | null;
  deviceDescription: string;
  paymentsSurchargeTotalInCents: number;
  deviceId: string;
  payments: Payment[];
  paymentsTotalInCents: number;
  source: TransactionSource;
  startedAt?: string | null;
  state: string;
  status: "COMPLETED" | "PENDING";
  transactionRef: string;
  transactionType: TransactionType;
  userDescription?: string | null;
  userId?: string | null;
};

export type StartTransactionFn = (
  amountInCents: number,
  transactionType: TransactionType
) => Promise<Transaction | ErrorResult>;

export type PollOutcomeFn = (transactionId: string) => Promise<Transaction>;
